import { IconWrapper } from "@insite/mobius/Icon";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

export interface ADICheckoutModalWrapperStyle {
    modalStyle?: ModalPresentationProps;
}

export const adiCheckoutModalWrapperStyle: ADICheckoutModalWrapperStyle = {
    modalStyle: {
        closeButtonProps: {
            css: css`
                padding: 0;
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        position:relative;
                        bottom:31px;
                    `,
                    css`
                    position:relative;
                    bottom:10px;
                    right:11px;
                    `,
                    css`
                    position:relative;
                    bottom:10px;
                    right:11px;
                    `,
                    css`
                      
                    `,
                    css`
                       
                    `,
                ])}
            `,
        },
        cssOverrides: {
            modalContainer: css`
                > div[class^="ContentBody"] {
                    max-width: 526px; //356px
                    overflow: hidden;
                    height: auto;
                    padding-bottom: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: 450px;
                            `,
                            css`
                                max-width: 820px;
                            `,
                            css`
                                max-width: 820px;
                            `,
                            css`
                                max-width: 820px;
                            `,
                            css`
                                max-width: 820px;
                            `,
                        ])}
                }
            `,
            modalBody: css`
                border-radius: 6px;
            `,

            modalContent: css`
                padding: 0px 30px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        padding:0px 10px 0px 20px;
                           
                        `,
                        css`
                      padding:0px 10px 0px 20px;
                           
                        `,
                        null,
                       null,
                        null,
                    ],
                    "max",
                )}
            `,

            modalTitle: css`
                border-bottom: unset;
                padding: 20px 30px 8px;
                // padding:30px 10px 0px 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        padding:25px 10px 8px 20px;
                           
                        `,
                        css`
                        padding:25px 10px 8px 20px;
                           
                        `,
                        null,
                       null,
                        null,
                    ],
                    "max",
                )}
                > ${TypographyStyle} {
                    font-size: 28px !important; // no size in style guide
                    font-weight: bold !important;
                    text-align: left;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                            font-size: 24px !important;
                            font-weight: bold !important;
                            text-align: left;
                            // padding:0px 10px 0px 20px;
                            line-height: normal;
                            margin-top: 0;
                            margin-bottom: 10px;
                            font-weight: bold;
                            max-width: 200px;
                               
                            `,
                            css`
                            font-size: 24px !important;
                            font-weight: bold !important;
                            text-align: left;
                            // padding:0px 10px 0px 20px;
                            line-height: normal;
                            margin-top: 0;
                            margin-bottom: 10px;
                            font-weight: bold;
                           width: auto;
                               
                            `,
                            null,
                           null,
                            null,
                        ],
                        "max",
                    )}

                  


                }
            `,
        },
    },
};

interface ADICheckoutModalWrapperProps {
    isOpen: boolean;
    handleClose: Function;
    headline: string;
    subheading?: string;
    children: JSX.Element;
    errorStyle: boolean;
}

const styles = adiCheckoutModalWrapperStyle;

const ADICheckoutModalWrapper = ({
    isOpen,
    handleClose,
    headline,
    subheading,
    children,
    errorStyle,
}: ADICheckoutModalWrapperProps) => {
    return (
        <Modal
            headline={headline}
            sizeVariant="large"
            isOpen={isOpen}
            handleClose={() => handleClose()}
            {...styles.modalStyle}
        >
            {children}
        </Modal>
    );
};

export default ADICheckoutModalWrapper;
